import { green, grey, orange, red } from "@mui/material/colors";
import { TransactionStatus } from "./types";

export const TRANSACTION_STATUS_META: Record<
  TransactionStatus,
  { label: string; backgroundColor: string; color: string }
> = {
  [TransactionStatus.IN_QUEUE]: {
    label: "В очереди",
    backgroundColor: orange[100],
    color: orange[600],
  },

  [TransactionStatus.IN_PROCESS]: {
    label: "В процессе",
    backgroundColor: orange[100],
    color: orange[600],
  },

  [TransactionStatus.NOT_VERIFIED]: {
    label: "Не подтверждена",
    backgroundColor: orange[100],
    color: orange[600],
  },

  [TransactionStatus.COMPLETED]: {
    label: "Выполнено",
    backgroundColor: green[100],
    color: green[600],
  },

  [TransactionStatus.CLOSED_BY_GATE]: {
    label: "Закрыта GATE",
    backgroundColor: grey[100],
    color: grey[600],
  },

  [TransactionStatus.CLOSED_BY_FINANCE_SUPPORT]: {
    label: "Закрыта ФП",
    backgroundColor: grey[100],
    color: grey[600],
  },

  [TransactionStatus.NOT_COMPLETED]: {
    label: "Не выполнено",
    backgroundColor: red[100],
    color: red[600],
  },
};
